import { Row, Col, Card, Button, Input, Form, Divider, Select, Spin } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { useNavigate } from "react-router";
import { Link, useLocation } from "react-router-dom";
import apiPath from "../../constants/apiPath";
import ContactDetail from "./ContactDetail";
const { Option } = Select;

function Add() {

  const sectionName   =   "Referral";
  const routeName     =   "referral";

  const api = {
    addEdit           :   apiPath.addEditReferral,
    generateCode      :   apiPath.generateReferralCode,
    commonBrandSearch :   apiPath.commonBrandSearch,
  }

  const location                                      =   useLocation();
  const navigate                                      =   useNavigate();
  const [form]                                        =   Form.useForm();
  const { request }                                   =   useRequest()
  const [loading, setLoading]                         =   useState(false)
  const [brandSearchList, setBrandSearchList]         =   useState([]);
  const [brandSearchLoading, setBrandSearchLoading]   =   useState(false);
  const debounceTimer                                 =   React.useRef(null);

  // The code is generated once when the page opens, it stays editable so a custom code can be typed
  const fetchReferralCode = () => {
    request({
      url: api.generateCode,
      method: 'GET',
      onSuccess: (response) => {
        form.setFieldsValue({ referral_code: response.data });
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      }
    })
  }

  const searchBrands = (searchValue) => {
    if (!searchValue || searchValue.trim() === '') {
      return;
    }

    setBrandSearchLoading(true);
    request({
      url: api.commonBrandSearch,
      method: 'POST',
      data: {
        query: searchValue.trim(),
        include_all: true
      },
      onSuccess: (response) => {
        setBrandSearchList(response.data?.data || []);
        setBrandSearchLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setBrandSearchList([]);
        setBrandSearchLoading(false);
      }
    })
  };

  const handleBrandSearch = (value) => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      searchBrands(value);
    }, 800);
  };

  const onCreate = (values) => {

    const payload = {
      ...values,
      contact_detail  :   values.contact_detail ? values.contact_detail : [],
    };

    setLoading(true)
    request({
      url: api.addEdit,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS)
          navigate(`/${routeName}${location.search}`);
        } else {
          ShowToast(data.message, Severty.ERROR)
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message || "Something went wrong, Please try again later", Severty.ERROR)
        setLoading(false)
      },
    })
  };

  useEffect(() => {
    fetchReferralCode();

    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [])

  return (
    <Card title={"Add New " + sectionName}>

      <Form className="edit-page-wrap" form={form} onFinish={onCreate} autoComplete="off" layout="vertical" name="referral_form">

        <Row gutter={[24, 0]}>

          <Col span={24} xs={24} sm={12} md={6}>
            <Form.Item
              label="Referral Code"
              name="referral_code"
              normalize={value => value ? value.trimStart().toUpperCase() : value}
              rules={[
                { required: true, message: "Please enter the referral code!" },
                { pattern: /^[a-zA-Z0-9]+$/, message: "Referral code should contain alphanumeric characters only!" },
                { max: 20, message: "Referral code should not contain more then 20 characters!" },
                { min: 4, message: "Referral code should contain at least 4 characters!" }
              ]}
            >
              <Input autoComplete="off" placeholder="Auto Generated Referral Code" />
            </Form.Item>
          </Col>

          <Col span={24} xs={24} sm={12} md={6}>
            <Form.Item
              label="Brand"
              name="brand_id"
              rules={[
                { required: true, message: "Please select the brand!" }
              ]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Search & select the brand"
                onSearch={handleBrandSearch}
                filterOption={false}
                loading={brandSearchLoading}
                notFoundContent={brandSearchLoading ? <Spin size="small" /> : "Type to search the brand"}
              >
                {brandSearchList?.map((item) => (
                  <Option key={item._id} value={item._id} label={item.name}>
                    <span className="cap">{item.name}</span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24} xs={24} sm={12} md={6}>
            <Form.Item
              label="Referrer Type"
              name="referrer_type"
              normalize={value => value ? value.trimStart() : value}
              rules={[
                { required: true, message: "Please enter the referrer type!" },
                { max: 255, message: "Referrer type should not contain more then 255 characters!" },
                { min: 2, message: "Referrer type should contain at least 2 characters!" }
              ]}
            >
              <Input autoComplete="off" placeholder="Ex. Service Center, Dealership" />
            </Form.Item>
          </Col>

          <Col span={24} xs={24} sm={12} md={6}>
            <Form.Item
              label="Name of Referrer"
              name="referrer_name"
              normalize={value => value ? value.trimStart() : value}
              rules={[
                { required: true, message: "Please enter the name of referrer!" },
                { max: 255, message: "Name of referrer should not contain more then 255 characters!" },
                { min: 2, message: "Name of referrer should contain at least 2 characters!" }
              ]}
            >
              <Input autoComplete="off" placeholder="Ex. PL Bajaj, Bluepine Yamaha" />
            </Form.Item>
          </Col>

          <Col span={24} xs={24} sm={24} md={24}>
            <Divider orientation="left" orientationMargin={15} className="devider-color">{"Referral Contact Details (CD)"}</Divider>
          </Col>

          <Col span={24} xs={24} sm={24} md={24}>
            <ContactDetail form={form} />
          </Col>

        </Row>

        <Form.Item className="btn-row float-right mt-3">
          <Link className="ant-btn ant-btn-secondary" to={`/${routeName}${location.search}`}><i className="fas fa-arrow-left mr-5"></i> Back</Link>
          <Button type="primary" loading={loading} htmlType="submit"><i className="fas fa-check mr-5"></i> Submit</Button>
        </Form.Item>

      </Form>
    </Card>
  )
}

export default Add;
